
var React =              require("react");
var CardActionItem = require("./generic/CardActionItem.jsx");
var DataActionUtil       = require("./../../util/DataActionUtil.js");

class ExportModel3DButton extends React.Component {

    constructor() {
        super();   
    }

    render() {  
        let actions = {
            'STEP': DataActionUtil.exportAsset, 
            'OBJ': DataActionUtil.exportAsset,
        }
        
        if(/(premium|education)/gi.test(this.props.typeUser)){
            actions['F3D'] = DataActionUtil.exportAsset;
        }
        
        return <CardActionItem
                    {...this.props}
                    text="Export"
                    iconText={
                        <React.Fragment>
                             <svg width="16" height="18" xmlns="http://www.w3.org/2000/svg">
                                 <use xlinkHref='#export' />
                             </svg>
                         </React.Fragment>
                    }
                    tooltip="Export Model"
                    action={actions}
        />

    }

}

module.exports = ExportModel3DButton;